"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilBacteria = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
class SoilBacteria extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.SOIL_BACTERIA,
            tags: [Tags_1.Tags.MICROBE],
            metadata: {
                cardNumber: 'P60',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(2).secondaryTag(Tags_1.Tags.MICROBE).plants(3);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('When playing a plant tag or a microbe tag, including this, gain 1 plant.', (eb) => {
                            eb.plants(1).played.slash().microbes(1).played.startEffect.plants(1);
                        });
                    });
                }),
                description: 'Draw 2 microbe cards and gain 3 plants.',
            },
        });
    }
    play(player) {
        player.drawCard(2, { tag: Tags_1.Tags.MICROBE });
        player.addResource(Resources_1.Resources.PLANTS, 3);
        return undefined;
    }
    onCardPlayed(player, card) {
        if (!player.cardIsInEffect(this.name))
            return;
        const resourceCount = card.tags.filter((tag) => tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE).length;
        if (resourceCount === 0)
            return undefined;
        player.addResource(Resources_1.Resources.PLANTS, resourceCount, { log: true });
        return undefined;
    }
}
exports.SoilBacteria = SoilBacteria;
//# sourceMappingURL=SoilBacteria.js.map